import { Box, Typography } from "@mui/material";
import React from "react";

const WhyUs = ({ sec }) => {
  return (
    <>
      <Box
        sx={{
          marginTop: "80px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "80px",
          marginInline: "60px",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          <Typography
            sx={{
              fontWeight: "700",
              fontSize: "35px",
              lineHeight: "35px",
              color: "#474747",
              textAlign: "center",
            }}
          >
            {sec.content?.heading}
          </Typography>

          <Typography sx={{ marginTop: "20px", textAlign: "center" }}>
            {sec.content?.body}
          </Typography>
        </Box>
        {/* <Box sx={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                    <Typography sx={{
                        fontWeight: "700", fontSize: "35px", lineHeight: "35px",
                        color: "#474747", textAlign: "center"
                    }} >

                        Our Features
                    </Typography>

                    <Typography sx={{ textAlign: "center", marginTop: "20px" }}>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla nec ultricies lorem.
                    </Typography>

                </Box> */}
      </Box>
    </>
  );
};
export default WhyUs;
